import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MyAssessmentCardProfile from "./MyAssessmentCardProfile";
import { checkIsInAssessment, getAllAssessment } from "../axios/axiosFunctions";

const MyAssessmentsProfile = ({ userId }) => {
  const [myAssessments, setMyAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const fetchEnrollment = async () => {
      setLoading(true);
      try {
        const allAssessments = await getAllAssessment();
        if (!allAssessments?.length) {
          setMyAssessments([]);
          return;
        }
        const results = await Promise.all(
          allAssessments.map(async (assessment) => {
            // For non-360 assessments, check the users array directly
            if (!assessment.is360) {
              const isInAssessment = assessment.users?.some(
                (a) => a._id === userId || a === userId,
              );
              return isInAssessment ? assessment : null;
            }
            // For 360 assessments, use the API which checks group membership
            const res = await checkIsInAssessment(assessment._id, userId);
            return res.isInAssessment ? assessment : null;
          }),
        );
        setMyAssessments(results.filter(Boolean));
      } catch (error) {
        console.log("Error fetching profile assessments:", error);
        setMyAssessments([]);
      } finally {
        setLoading(false);
      }
    };
    fetchEnrollment();
  }, [userId]);

  return (
    <Container sx={{ marginTop: "50px" }}>
      <Accordion
        sx={{
          width: "100%",
          height: "max-content",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <AccordionSummary expandIcon={<ArrowDropDownIcon color="primary" />}>
          <Typography variant="h5" fontWeight={600} color="primary">
            My Assessments
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Container
            sx={{
              padding: "1.25rem",
              display: "flex",
              flexDirection: "column",
              gap: "4rem",
            }}
          >
            {loading && <CircularProgress />}
            {!loading &&
              myAssessments.map((assessment, i) => (
                <Grid key={i} size={12}>
                  <MyAssessmentCardProfile assessment={assessment} />
                </Grid>
              ))}
          </Container>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};

export default MyAssessmentsProfile;
